const pwa = {
  installTitle: "התקן את GAM CC",
  installDescription: "קבל גישה מהירה ישירות ממסך הבית — עובד גם אופליין",
  installButton: "התקן",
  iosShareGuide: "לחץ על כפתור השיתוף ואז ״הוסף למסך הבית״",
  offlineTitle: "אין חיבור לאינטרנט",
  offlineDescription: "לא ניתן לגשת לדף זה במצב אופליין. בדוק את חיבור האינטרנט ונסה שוב.",
  offlineRetry: "נסה שוב",
  pushEnable: "הפעל התראות",
  pushDisable: "כבה התראות",
  pushEnabled: "התראות פעילות",
  pushNotSupported: "התראות לא נתמכות בדפדפן זה",
  pushBlocked: "התראות חסומות — יש לאפשר בהגדרות הדפדפן",
  installationStatus: "מצב התקנה",
  installedStandalone: "מותקן (Standalone)",
  runningInBrowser: "רץ בדפדפן",
  installApp: "התקן אפליקציה",
  iosInstallHint: "ב-Safari: לחץ שיתוף → הוסף למסך הבית",
  appName: "שם האפליקציה",
  appDescription: "תיאור",
  pushNotifications: "התראות דחיפה",
  pushPermission: "הרשאת התראות",
  permGranted: "אושר",
  permDenied: "נדחה",
  permPrompt: "ממתין",
  permUnsupported: "לא נתמך",
  enablePush: "הפעל התראות",
  disablePush: "כבה התראות",
  sendTestPush: "שלח התראת ניסיון",
  testPushSent: "התראת ניסיון נשלחה",
  notificationTemplates: "תבניות התראות",
  templateStatus: "עדכון סטטוס",
  templateMention: "אזכור",
  templateDeadline: "דדליין",
  templateAi: "תגובת AI",
  templateTitle: "כותרת",
  templateBody: "תוכן",
  templateVars: "משתנים: {{project}}, {{user}}, {{date}}",
  notifPreferences: "העדפות התראות",
  notifWhatsapp: "WhatsApp",
  notifPhone: "שיחות",
  notifSms: "SMS",
  notifEmail: "מייל",
  notifNote: "הערות",
  notifReminder: "תזכורות",
  notifSync_summary: "סנכרון",
  cameraScanner: "מצלמה וסורק",
  cameraPermission: "הרשאת מצלמה",
  requestCamera: "בקש הרשאה",
  scanQR: "סרוק QR",
  scanResult: "תוצאת סריקה",
  takePhoto: "צלם תמונה",
  photoPreview: "תצוגה מקדימה",
  clearPhoto: "נקה",
  contacts: "אנשי קשר",
  contactsSupported: "נתמך",
  contactsNotSupported: "לא נתמך בדפדפן זה",
  contactsHint: "Contact Picker API זמין רק ב-Chrome Android",
  importContacts: "ייבוא אנשי קשר",
  contactName: "שם",
  contactEmail: "אימייל",
  contactPhone: "טלפון",
  noContacts: "לא יובאו אנשי קשר",
  clearContacts: "נקה רשימה",
  deviceCapabilities: "יכולות מכשיר",
  webShare: "שיתוף",
  testShare: "בדוק שיתוף",
  wakeLock: "מניעת כיבוי מסך",
  wakeLockActive: "המסך יישאר דלוק",
  vibration: "רטט",
  testVibration: "בדוק רטט",
  geolocation: "מיקום",
  getLocation: "קבל מיקום",
  badgeApi: "Badge API",
  backgroundSync: "Background Sync",
  serviceWorkerStatus: "Service Worker",
  supported: "נתמך",
  notSupported: "לא נתמך",
  active: "פעיל",
  inactive: "לא פעיל",
  pushAdmin: "ניהול מנויי Push",
  subscriberEmail: "אימייל",
  subscriberDate: "תאריך הרשמה",
  subscriberLastActive: "פעילות אחרונה",
  sendToUser: "שלח",
  sendToAll: "שלח לכולם",
  cleanExpired: "נקה פגי תוקף",
  cleaning: "מנקה...",
  cleaned: "נוקו",
  noSubscribers: "אין מנויי push עדיין",
  loading: "טוען...",
} as const;
export default pwa;
